query UserApps {
  userApps {
    nodes {
      linkTypeId
      linkType
      linkTitle
      linkHint
    }
  }
}
